import React from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {
  ProcessTaskDefinitionVersionGraphQL,
  TaskNodeDetailsSidepanelContentProps,
} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorConstants';
import {TaskDefinitionVersionSpecWithTaskSchema} from 'processes/settings/graph-builder-flowchart-config/horizontal-flowchart/processFlowchartConfigEditorNodeTypes';

type AnalysisTemplateType = ExtractByTypename<
  ProcessTaskDefinitionVersionGraphQL['applicationData'],
  'AnalysisTemplateNode'
>;

export default function PipelineNodeSidepanelContent(
  props: TaskNodeDetailsSidepanelContentProps
): JSX.Element {
  const selectedNodeTaskDefinitionVersionSpec =
    props.selectedNodeTaskDefinitionVersionSpec as TaskDefinitionVersionSpecWithTaskSchema<AnalysisTemplateType>;
  const analysisTemplate =
    selectedNodeTaskDefinitionVersionSpec.newProcessTaskDefinitionVersion.applicationData;

  if (analysisTemplate == null) {
    return <div>No analysis template</div>;
  }

  return <div>{analysisTemplate.name}</div>;
}
